import React from "react";

import CustomSelect from "../ui/CustomSelect";
const InvoicesTablePagination = ({
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPageChange,
  onPageSizeChange,
}) => {
  const start =
    totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const end =
    totalItems === 0
      ? 0
      : Math.min(currentPage * itemsPerPage, totalItems);

  const getVisiblePages = () => {
    const pages = [];
    const maxVisible = 5;

    let startPage = Math.max(
      1,
      currentPage - Math.floor(maxVisible / 2)
    );
    let endPage = startPage + maxVisible - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  const visiblePages = getVisiblePages();
  const btnBase =
    "px-3 py-1.5 text-[13px] border border-[var(--line-strong,#d5d3cc)] rounded-md bg-white text-[var(--ink,#1c1c1a)] hover:bg-[var(--sunken,#eeece7)] disabled:opacity-40 disabled:cursor-not-allowed";

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between mt-4 pt-4 border-t border-[var(--line,#e4e2dc)]">
      <div className="flex items-center gap-2 text-[13px] text-[var(--muted,#6b6a66)]">
        <span>Show</span>
        <CustomSelect
          value={itemsPerPage}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="border border-[var(--line-strong,#d5d3cc)] rounded-md px-2 py-1.5 text-[13px] bg-white focus:outline-none focus:ring-2 focus:ring-[var(--muted,#6b6a66)]/20 focus:border-[var(--muted,#6b6a66)]"
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </CustomSelect>
        <span>entries</span>
      </div>

      <div className="flex items-center justify-center gap-1 flex-nowrap">
        <button
          type="button"
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          className={btnBase}
        >
          ««
        </button>
        <button
          type="button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={btnBase}
        >
          Prev
        </button>
        {visiblePages.map((page) => (
          <button
            key={page}
            type="button"
            onClick={() => onPageChange(page)}
            className={`min-w-[36px] h-9 text-[13px] border rounded-md ${
              currentPage === page
                ? "border-[var(--accent,#a51c1c)] bg-[var(--accent,#a51c1c)] text-white"
                : "border-[var(--line-strong,#d5d3cc)] bg-white text-[var(--ink,#1c1c1a)] hover:bg-[var(--sunken,#eeece7)]"
            }`}
          >
            {page}
          </button>
        ))}
        <button
          type="button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
          className={btnBase}
        >
          Next
        </button>
        <button
          type="button"
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages || totalPages === 0}
          className={btnBase}
        >
          »»
        </button>
      </div>

      <p className="text-[13px] text-[var(--muted,#6b6a66)] sm:text-right">
        Showing {start}–{end} of {totalItems} entries
      </p>
    </div>
  );
};

export default InvoicesTablePagination;